import React from "react";
import Form from "./form";
import { Link } from "react-router-dom";
import { CREATE_PERSONA } from "./query";
import { SectionTitle } from "../../../shared";

function CreatePersonaGroup() {
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="shadow p-5">
                        <Link
                            to="/abbvie-pro/persona/group"
                            className="btn btn-outline-primary mb-4"
                        >
                            Back
                        </Link>
                        <SectionTitle title="Create Persona Group" />
                        <Form query={CREATE_PERSONA} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreatePersonaGroup;
